import moment from "moment-timezone";

const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
moment.tz.setDefault(timeZone);

export default moment;
